// extracted by mini-css-extract-plugin
export default {"buttons":"zoom-btns_buttons__zNjde","icon-button":"zoom-btns_icon-button__iZ1iG"};